const FormFieldType = {
  TEXT: 1,
  SELECT: 2,
  RADIO: 3,
  CHECKBOX: 4,
  PASSWORD: 5,
  NUMBER: 6,
  HIDDEN: 7,
  URL: 8,
  FILE: 9,
  properties: {
    1: { description: 'text' },
    2: { description: 'select' },
    3: { description: 'radio' },
    4: { description: 'checkbox' },
    5: { description: 'password' },
    6: { description: 'number' },
    7: { description: 'hidden' },
    8: { description: 'url' },
    9: { description: 'file' },
  },
}

if (Object.freeze) {
  Object.freeze(FormFieldType)
}

export { FormFieldType }
